var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupKnockoutPhase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 125,
    viewBox: "0 0 332 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_96832)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 158,
    height: 124,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 20.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 12.5H35C33.3431 12.5 32 13.8431 32 15.5C32 17.1569 33.3431 18.5 35 18.5H61C62.6569 18.5 64 17.1569 64 15.5C64 13.8431 62.6569 12.5 61 12.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 22.5H35C33.3431 22.5 32 23.8431 32 25.5C32 27.1569 33.3431 28.5 35 28.5H79C80.6569 28.5 82 27.1569 82 25.5C82 23.8431 80.6569 22.5 79 22.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 48.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 40.5H35C33.3431 40.5 32 41.8431 32 43.5C32 45.1569 33.3431 46.5 35 46.5H61C62.6569 46.5 64 45.1569 64 43.5C64 41.8431 62.6569 40.5 61 40.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 50.5H35C33.3431 50.5 32 51.8431 32 53.5C32 55.1569 33.3431 56.5 35 56.5H79C80.6569 56.5 82 55.1569 82 53.5C82 51.8431 80.6569 50.5 79 50.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 76.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 68.5H35C33.3431 68.5 32 69.8431 32 71.5C32 73.1569 33.3431 74.5 35 74.5H61C62.6569 74.5 64 73.1569 64 71.5C64 69.8431 62.6569 68.5 61 68.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 78.5H35C33.3431 78.5 32 79.8431 32 81.5C32 83.1569 33.3431 84.5 35 84.5H79C80.6569 84.5 82 83.1569 82 81.5C82 79.8431 80.6569 78.5 79 78.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 104.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61 96.5H35C33.3431 96.5 32 97.8431 32 99.5C32 101.157 33.3431 102.5 35 102.5H61C62.6569 102.5 64 101.157 64 99.5C64 97.8431 62.6569 96.5 61 96.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 106.5H35C33.3431 106.5 32 107.843 32 109.5C32 111.157 33.3431 112.5 35 112.5H79C80.6569 112.5 82 111.157 82 109.5C82 107.843 80.6569 106.5 79 106.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.125 61.5L165.125 61.5C165.677 61.5 166.125 61.0523 166.125 60.5V23.5C166.125 22.9477 166.573 22.5 167.125 22.5H174.125",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.125 102.5H167.125C166.573 102.5 166.125 102.052 166.125 101.5V82.281V62.5C166.125 61.9477 165.677 61.5 165.125 61.5H158.125",
    stroke: "#192634"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 2.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 22.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 14.5H209C207.343 14.5 206 15.8431 206 17.5C206 19.1569 207.343 20.5 209 20.5H235C236.657 20.5 238 19.1569 238 17.5C238 15.8431 236.657 14.5 235 14.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 24.5H209C207.343 24.5 206 25.8431 206 27.5C206 29.1569 207.343 30.5 209 30.5H253C254.657 30.5 256 29.1569 256 27.5C256 25.8431 254.657 24.5 253 24.5Z",
    fill: "#CBCDC2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 82.5,
    width: 158,
    height: 40,
    rx: 8,
    fill: "#26333D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 102.5,
    r: 10.4167,
    fill: "#4C565D",
    stroke: "#26333D",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2396_96832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235 94.5H209C207.343 94.5 206 95.8431 206 97.5C206 99.1569 207.343 100.5 209 100.5H235C236.657 100.5 238 99.1569 238 97.5C238 95.8431 236.657 94.5 235 94.5Z",
    fill: "#7F8585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 104.5H209C207.343 104.5 206 105.843 206 107.5C206 109.157 207.343 110.5 209 110.5H253C254.657 110.5 256 109.157 256 107.5C256 105.843 254.657 104.5 253 104.5Z",
    fill: "#CBCDC2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 124,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 12.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 40.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 68.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(32 96.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 14.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2396_96832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 16,
    fill: "white",
    transform: "translate(206 94.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupKnockoutPhase);
export default __webpack_public_path__ + "static/media/group-knockout-phase.077466de7fad674e3ff94e914cf42d48.svg";
export { ForwardRef as ReactComponent };